import React from 'react';
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';
import Canvas from './Components/Canvas/Canvas.js';
import Splash from './Components/Splash/Splash.js';
import Nav from './Components/Nav/Nav.js';
import MobileNav from './Components/Nav/MobileNav.js';
import About from './Components/About/About.js';
import Contact from './Components/About/Contact.js';
import Blog from './Components/Blog/Blog.js';
import Code from './Components/Code/Code.js';
import Project from './Components/Project/Project.js';
import Settings from './Components/Settings/Settings.js';
import projectData from './projectData.js'
import blogData from './blogData.js'
import './App.css';


class App extends React.PureComponent {
  static checkWebGLSupport() {
    try {
      const canvas = document.createElement('canvas');
      return !!(window.WebGLRenderingContext && (
        canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
      ));
    } catch (e) {
      return false;
    }
  }

  constructor(props) {
    super(props);
    this.handleOrientationChange = this.handleOrientationChange.bind(this);
    this.state = {
      videoDisabled: false,
      uniforms: [0.25, 250, 200, 81],
      webglSupported: App.checkWebGLSupport(),
    }
  }

  componentDidMount() {
    // Attempt to hide the address bar when the component mounts
    this.hideSafariAddressBar();
    // Add event listener to re-run the function if the user rotates the device
    window.addEventListener('orientationchange', this.handleOrientationChange);
  }

  componentWillUnmount() {
    // Clean up the event listener when the component is removed
    window.removeEventListener('orientationchange', this.handleOrientationChange);
  }

  handleOrientationChange() {
    this.hideSafariAddressBar();
  }
  
  hideSafariAddressBar() {
    // This timeout is crucial. It gives the browser a moment to render
    // and calculate the viewport dimensions correctly on mobile devices.
    setTimeout(() => {
      // If the user is at the very top of the page, scroll down 1 pixel.
      if (window.scrollY === 0) {
        // Scrolling 1px down forces Safari to start the address bar hiding mechanism.
        window.scrollTo(0, 1);
      }
    }, 100);
  }

  toggleVideo = (e) => {
    if (this.state.videoDisabled === !this.state.videoDisabled) return;
    this.setState({
      videoDisabled: !this.state.videoDisabled
    });
  }

  sliderHandler = (e) => {
    let target = Number(e.target.dataset.target);
    let uniforms = this.state.uniforms.map(u => u);
    const newValue = Number(e.target.value);
    if (uniforms[target] === newValue) return;
    uniforms[target] = newValue;
    this.setState({ uniforms });
  }

  render() {
    return (
      <div className="App">
        <Router>
          <Nav />
          <MobileNav />
            <Switch>
              <Route exact path="/">
                <Splash />
              </Route>
              <Route className='flex' path="/about">
                <About />
              </Route>
              <Route className='flex' path="/contact">
                <Contact />
              </Route>
              <Route className='flex' exact path="/blog">
                <Blog />
              </Route>
              {
                blogData.map((project, i) => (
                  <Route key={project.name} path={project.path}>
                    <Project project={project} key={i} fxDisabled={this.state.fxDisabled}/>
                  </Route>
                ))
              }
              <Route className='flex' exact path="/code">
                <Code />
              </Route>
              {
                projectData.map((project, i) => (
                  <Route key={project.name} path={project.path}>
                    <Project project={project} key={i} fxDisabled={this.state.fxDisabled}/>
                  </Route>
                ))
              }
            </Switch>
          <Settings
            uniforms={this.state.uniforms}
            toggleVideo={this.toggleVideo}
            sliderHandler={this.sliderHandler}
            fxDisabled={this.state.fxDisabled}
            videoDisabled={this.state.videoDisabled}
            webglSupported={this.state.webglSupported}
          />
        </Router>
        <Canvas
          uniforms={this.state.uniforms}
          videoDisabled={this.state.videoDisabled}
          webglSupported={this.state.webglSupported}
        />
      </div>
    );
  }
}

export default App;
